// extracted by mini-css-extract-plugin
export default {"form":"Unsubscribe_form__Mw2V9","label":"Unsubscribe_label__zZHLp","input":"Unsubscribe_input__a64q4","submit":"Unsubscribe_submit__ZRki3"};